import config from "../../config/environment";
import type { SessionSettingsResponse } from "./types";

/**
 * Utilitários de lobby para salas de teste em DEV.
 * Em build de produção (REACT_APP_ENVIRONMENT=production) estas funções são no-op.
 */

export const DEV_TEST_ROOM_SUFFIXES = ["-seedtest", "-dev-test"] as const;

export function isDevBuild(): boolean {
    return config.environment === "development";
}

export function isDevTestRoomId(roomId: string): boolean {
    return DEV_TEST_ROOM_SUFFIXES.some((suffix) => roomId.endsWith(suffix));
}

/** Override síncrono — não depende do Firestore (útil quando o doc da sala ainda não existe). */
export function applyDevTestLobbyOverride(
    response: SessionSettingsResponse,
    roomId: string,
): SessionSettingsResponse {
    if (!isDevBuild() || !isDevTestRoomId(roomId)) {
        return response;
    }

    return {
        ...response,
        canAccessRoom: true,
        entryApproved: true,
        devTestOpen: true,
        userHasCredits: true,
    };
}

export function canProceedToDevTestLobby(
    response: SessionSettingsResponse | null | undefined,
    options?: { preferLiveKit?: boolean },
): boolean {
    if (!response?.canAccessRoom) {
        return false;
    }

    if (response.livekitOpenTest) {
        return true;
    }

    if (options?.preferLiveKit) {
        return Boolean(
            response.isRoomModerator ||
                response.isRoomOwner ||
                response.entryApproved ||
                response.dyteMeetingAlreadyExists,
        );
    }

    return Boolean(
        response.dyteMeetingAlreadyExists ||
            response.isRoomModerator ||
            (isDevBuild() && response.devTestOpen === true),
    );
}
